export const state = () => ({
	totalItems: null,
	currentPage: 1,
	rowsPerPage: 50,
	itemsPerPageOptions: [10, 25, 50, 75, 100, 200, 400, 500],
});

export const mutations = {
	setTotalItems(state, payload) {
		state.totalItems = payload;
	},
	setCurrentPage(state, payload) {
		state.currentPage = payload;
	},
	setRowsPerPage(state, payload) {
		state.rowsPerPage = payload;
	},
};

export const getters = {
	getCurrentPage: (state) => state.currentPage,
	getTotalItems: (state) => state.totalItems,
	getRowsPerPage: (state) => state.rowsPerPage,
	getItemsPerPageOptions: (state) => state.itemsPerPageOptions,
};
